import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearAuthSessionAction, verifyVendorTokenAction } from "../actions/auth";
import { getAuthToken } from "../utils/authStorage";

export default function RequireGuest() {
  const dispatch = useDispatch();
  const isLogin = useSelector((state) => Boolean(state.auth?.isLogin));
  const [verification, setVerification] = useState(() => {
    if (isLogin && getAuthToken()) return "authenticated";
    return getAuthToken() ? "checking" : "guest";
  });

  useEffect(() => {
    let active = true;
    const token = getAuthToken();

    if (!token) {
      if (isLogin) dispatch(clearAuthSessionAction());
      setVerification("guest");
      return () => {
        active = false;
      };
    }

    if (isLogin) {
      setVerification("authenticated");
      return () => {
        active = false;
      };
    }

    setVerification("checking");
    dispatch(verifyVendorTokenAction())
      .then((result) => {
        if (!active) return;
        if (getAuthToken() !== token) {
          setVerification(getAuthToken() ? "checking" : "guest");
          return;
        }
        setVerification(result?.verified ? "authenticated" : "guest");
      })
      .catch(() => {
        if (active) setVerification("guest");
      });

    return () => {
      active = false;
    };
  }, [dispatch, isLogin]);

  if (verification === "checking") {
    return (
      <div className="route-auth-loading" role="status" aria-label="Loading">
        <span />
      </div>
    );
  }

  if (verification === "authenticated" && getAuthToken()) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
